import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ShortReport from "./ShortReport";
import VideoReport from "./VideoReport";
import PageContainer from "../../Component/Common/Page";
import PageHeader from "../../Component/Common/PageHeader";
import MultiButton from "../../Component/extra/MultiButton";

export default function ManageReport() {
  const [multiButtonSelect, setMultiButtonSelect] = useState("Shorts Report");

  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  useEffect(() => {
    console.log("multiButtonSelect", multiButtonSelect);
  }, []);

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);
  return (
    <PageContainer className="userPage channelPage">
      <PageHeader
        heading={"Welcome Admin"}
        subHeading={"Report"}
        showDateRange={true}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      <MultiButton
        label={["Shorts Report", "Video Report"]}
        multiButtonSelect={multiButtonSelect}
        setMultiButtonSelect={setMultiButtonSelect}
      />

      {multiButtonSelect == "Shorts Report" && (
        <ShortReport endDate={endDateData} startDate={startDateData} />
      )}
      {multiButtonSelect == "Video Report" && (
        <VideoReport
          endDate={endDateData}
          startDate={startDateData}
          setMultiButtonSelect={setMultiButtonSelect}
        />
      )}
    </PageContainer>
  );
}
